module.exports = __webpack_public_path__ + "img/ar15.d351ed68.jpg";